export const SO_FLEX_TARIFF_CODE = "SOOC"
export const SO_FLEX_GREEN_TARIFF_CODE = "SGRN"
export const SO_GREEN_TRACKER_TARIFF_CODE = "STRG"
